export default "__VITE_ASSET__Cqt3eyer__"